<template>
  <div>
    <div class="widewrapper main">
        <div class="container">
            <div class="row">
                <div class="col-md-8 blog-main info markdown-body">
                  <div v-html="content" />
                </div>
                <aside class="col-md-4 blog-aside">
                    <navi></navi>
                </aside>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import navi from "../components/navi"
export default {
  name: 'Info',
  data () {
    return {
      link: '',
      title: '',
      keyword: '',
      description: '',
      content: '',
    }
  },
  metaInfo() {
      return {
        title: this.title,
        meta: [
          { name: "keywords", content: this.keyword },
          { name: "description", content: this.description },
        ],
      };
  },
  components: {
      navi,
  },
  mounted : function(){
    this.link = this.$route.params.link;
    if (this.link == undefined) {
      this.$router.push({
          name: 'List',
          params: {}
      })
    }
    this.getData(this.link)
  },
  watch:{ 
    content : function() {
     this.$nextTick(function(){
      var width  = document.documentElement.clientWidth;
      var images = document.images
      for (var i = 0; i < images.length; i++) {
          images[i].style.width = width > 375 ? '500px' : '300px';
      }
      var logo_img = document.getElementById('logo_img');
      logo_img.style.width = width > 375 ? '260px' : '200px';
     });
    }
  },
  methods : {
    getData: function (link) {
      var that = this
      let params = {
          link : link,
      }
      this.$api.getBlogInfo(params).then((res)=>{
          that.content = res.data.Html
          that.title = res.data.Title + "@范祯的博客";
          that.keyword = res.data.Keyword
          that.description = res.data.Description
      }).catch((res)=>{
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Info.vue